<template>
    <div id="app">
        <Home v-if="Mobile"></Home>
        <Mobile v-if="!Mobile"></Mobile>
        <button class='but' @click='tet()'>PC模式</button>
    </div>
</template>

<script>
    // import {Message} from 'element-ui'
    import Home from "./components/home/home";
    import Mobile from "./components/mobile"
    export default {
        name: "App",
        components: {
            Home,
            Mobile
        },
        mounted() {
            this.isMobile()

            // if(document.getElementsByClassName('mobile-left')[0]){
            //     console.log(document.getElementsByClassName('mobile-left')[0].clientWidth)
            //     document.getElementsByClassName('but')[0].style.left=document.getElementsByClassName('mobile-left')[0].clientWidth-80+'px';
            // }

            // window.onresize=function(){
            //     console.log('123');
            //     var but=document.getElementsByClassName('but')[0];
            //     var but1=document.getElementsByClassName('mobile-left')[0];
            //     if(but1){
            //         //console.log(Mobile);
            //         console.log(but1.clientWidth);
            //         but.style.left=but1.clientWidth-80+'px';
            //     }
            // }
        },
        data() {
            return {
                isRouterAlive: true,
                Mobile: false
            };
        },
        methods: {
            reload: function () {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true;
                });
            },
            isMobile: function () {
                let flag = navigator.userAgent.match(
                    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|windows)/i
                );
                if (flag) {
                    console.log("移动端打开");
                    // Message.success({message: '横屏浏览更佳!'});
                    this.Mobile = false
                    //return false;
                } else {
                    // console.log("PC端打开");
                    // this.Mobile = true
                    // Message.success({message: '欢迎使用pc端体验!'});
                }
            },
            tet(){
                if(!this.Mobile){
                    this.Mobile=true;
                    document.getElementsByClassName('but')[0].innerHTML="移动模式"
                    document.getElementsByClassName('but')[0].style.color='black'
                    document.getElementsByClassName('but')[0].style.background='white'
                    // console.log(document.getElementsByClassName('classification')[0].clientWidth);
                    // document.getElementsByClassName('but')[0].style.left=document.getElementsByClassName('mobile-leftclassification')[0].clientWidth-80+'px';
                }else if(this.Mobile){
                    this.Mobile=false;
                    document.getElementsByClassName('but')[0].innerHTML="PC模式"
                    document.getElementsByClassName('but')[0].style.color='white'
                    document.getElementsByClassName('but')[0].style.background='none'
                    // console.log(document.getElementsByClassName('mobile-left')[0].clientWidth);
                    // document.getElementsByClassName('but')[0].style.left=document.getElementsByClassName('classification')[0].clientWidth-80+'px';
                }
            }
        },
    };
</script>

<style>
    * {
        margin: 0;
        padding: 0;
        cursor: default;
    }

    html,
    body,
    #app {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .but{
        width: 70px;
        height: 30px;
        background: none;
        border: 1px white solid;
        border-radius: 20px;
        color: white;
        font-size: 14px;
        line-height: 30px;
        position: fixed;
        right: 71vw;
        bottom: 20px;
        outline: none;
    }

    button:focus{
        outline: none;
    }
</style>
